import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'msOptionGroupPair', standalone: true })
export class OptionGroupPairPipe implements PipeTransform {
    transform<T>(options: T[]): T[][] {
        return options.filter((value, index) => index % 2 === 0).map((value, index) => [options[index * 2], options[index * 2 + 1]]);
    }
}
